import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Input, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { UserInfoService } from '@wlp/ui-bs-login';
import { AccountBalanceService, NotificationsService } from '@wlp/ui-bs-cashin';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCAccountBalanceModule } from '@wlp/ui-c-account-balance';
import { UiCBarInfoModule } from '@wlp/ui-c-bar-info';

let UICHeaderUserInfoService = class UICHeaderUserInfoService {
    constructor(userInfoService, accountBalanceService) {
        this.userInfoService = userInfoService;
        this.accountBalanceService = accountBalanceService;
        this.uuid$ = new Subject();
        this.value$ = new Subject();
        this.uuid = '';
        this.value = false;
        // inicia os observales
        this.initiateObservable();
    }
    initiateObservable() {
        this.uuid$.subscribe(res => this.uuid = res);
        this.value$.subscribe(res => this.value = res);
    }
    loadBalance(uuidWL, uuidAccount) {
        this.accountBalanceService
            .getBalance(uuidWL, uuidAccount)
            .then(res => this.accountBalanceService.setBalanceSubject(res.balance))
            .catch(err => this.accountBalanceService.getErroMessage(err));
    }
    loadUser() {
        try {
            const userDetails = this.userInfoService.getInfoProfile();
            userDetails.then(user => {
                this.loadBalance(user.uuidWhiteLabel, user.uuidAccount);
            });
        }
        catch (e) {
            console.error('Failed to load user details', e);
        }
    }
    loadUserUUID() {
        this.userInfoService.getInfoProfile().then(user => this.updateUuid(user.uuidAccount));
    }
    updateValue(value) {
        this.value$.next(value);
    }
    updateUuid(uuid) {
        this.uuid$.next(uuid);
    }
    getUuid() {
        return this.uuid;
    }
    getValue() {
        return this.value;
    }
    getObservable() {
        return this.uuid$.asObservable();
    }
    getValueObservable() {
        return this.value$.asObservable();
    }
};
UICHeaderUserInfoService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UICHeaderUserInfoService_Factory() { return new UICHeaderUserInfoService(ɵɵinject(UserInfoService), ɵɵinject(AccountBalanceService)); }, token: UICHeaderUserInfoService, providedIn: "root" });
UICHeaderUserInfoService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [UserInfoService,
        AccountBalanceService])
], UICHeaderUserInfoService);

let UICHeaderUserInfoComponent = class UICHeaderUserInfoComponent {
    constructor(accountBalanceService, notificationsService, headerInfoService) {
        this.accountBalanceService = accountBalanceService;
        this.notificationsService = notificationsService;
        this.headerInfoService = headerInfoService;
        this.showBLC = false;
        this.messages = [];
        this.iconName = 'eye-off-outline';
        this.balance = '';
        this.loadInitialData();
        this.loadValueUpdate();
        // atualiza o uuid do usuario
        this.headerInfoService.loadUserUUID();
        this.loadMessages();
    }
    loadInitialData() {
        this.headerInfoService.loadUser();
        this.accountBalanceService.getBalanceSubject().pipe(tap(data => {
            this.balanceSubject$ = String(data);
        })).subscribe();
    }
    showBalance() {
        if (this.iconName === 'eye-off-outline') {
            this.iconName = 'eye-outline';
            this.showBLC = true;
        }
        else {
            this.iconName = 'eye-off-outline';
            this.showBLC = false;
        }
    }
    loadMessages() {
        if (this.headerInfoService.uuid !== '') {
            this.messages = this.notificationsService.getNotification(this.headerInfoService.uuid);
        }
        else {
            this.headerInfoService.getObservable().subscribe(res => {
                this.messages = this.notificationsService
                    .getNotification(res);
            });
        }
    }
    loadValueUpdate() {
        this.headerInfoService.getValueObservable().subscribe(res => this.loadInitialData());
    }
    reloadBalanceByClick() {
        this.reloadIconBalance = true;
        setTimeout(() => {
            this.reloadIconBalance = false;
        }, 2000);
        this.headerInfoService.loadUser();
        this.accountBalanceService.getBalanceSubject().pipe(tap(data => {
            this.balanceSubject$ = String(data);
        })).subscribe();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UICHeaderUserInfoComponent.prototype, "reload", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UICHeaderUserInfoComponent.prototype, "infoMessage", void 0);
UICHeaderUserInfoComponent = __decorate([
    Component({
        selector: 'ui-c-header-user-info',
        template: "<ion-row class=\"ui-c-header-user-info row-balance-info\">\n  <ion-col size=\"12\" size-lg=\"3\">\n    <ui-c-account-balance class=\"w-100\" [textTitle]=\"'DASHBOARD.BALANCE.TITLE'\" (clickEvent)=\"showBalance()\"\n      [iconName]=\"iconName\" [showBLC]=\"showBLC\" (clickReload)=\"reloadBalanceByClick()\" [reload]=\"reload\"\n      [reloadIcon]=\"reloadIconBalance\">\n      <ion-text class=\"ion-text-left font-size-17 font-family-semibold\">\n        <span>\n          {{ balanceSubject$ | currency: 'BRL' }}\n        </span>\n      </ion-text>\n    </ui-c-account-balance>\n  </ion-col>\n  <ion-col class=\"col-info-principal d-none d-lg-flex\" size=\"12\" size-lg=\"9\">\n    <ui-c-bar-info [infoMessage]=\"infoMessage\" [messages]=\"messages\"></ui-c-bar-info>\n  </ion-col>\n</ion-row>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [AccountBalanceService,
        NotificationsService,
        UICHeaderUserInfoService])
], UICHeaderUserInfoComponent);

let HeaderUserInfoModule = class HeaderUserInfoModule {
};
HeaderUserInfoModule = __decorate([
    NgModule({
        declarations: [
            UICHeaderUserInfoComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiCAccountBalanceModule,
            UiCBarInfoModule,
            UiBsTranslateModule
        ],
        providers: [
            UICHeaderUserInfoService
        ],
        exports: [
            UICHeaderUserInfoComponent
        ]
    })
], HeaderUserInfoModule);

export { HeaderUserInfoModule, UICHeaderUserInfoComponent, UICHeaderUserInfoService };
//# sourceMappingURL=wlp-ui-c-header-user-info.js.map
